import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainLearnerRoutingModule } from './main-learner-routing.module';



// OTHER MODULE IMPORTS

import { SharedModule } from '../../shared.module';
import { MaterialsModule } from '../../materials.module';
import { MainDocumentModule } from '../../documents/main-document/main-document.module';
import { MainMedicalModule } from '../../medical/main-medical/main-medical.module';
import { MainPortfolioModule } from '../../portfolio/main-portfolio/main-portfolio.module';
import { MainCourseModule } from '../../courses/main-course/main-course.module';

// IMPORT LEARNER MODULE COMPONENTS
import { MainLearnerComponent } from './main-learner.component';
import { LearnersComponent } from '../learners.component';
import { SingleLearnerComponent } from '../single-learner/single-learner.component';
import { AddLearnerModalComponent } from '../add-learner-modal/add-learner-modal.component';
import { EditLearnerModalComponent } from '../edit-learner-modal/edit-learner-modal.component';
import { LearnerSubmissionComponent } from '../learner-submission/learner-submission.component';
import { LearnerAllotmentTileComponent } from '../learner-allotment-tile/learner-allotment-tile.component';
import { LearnerDashboardComponent } from '../learner-dashboard/learner-dashboard.component';
import { LearnerReadingMaterialComponent } from '../learner-reading-material/learner-reading-material.component';
import { ExamsResultsComponent } from '../exams-results/exams-results.component';
import { MatInputComponent } from '../exams-results/mat-input/mat-input.component';
import { LearnerPortfolioComponent } from '../learner-portfolio/learner-portfolio.component';
import { PortfolioPolicyComponent } from '../portfolio-policy/portfolio-policy.component';
import { TrainingPlanComponent } from '../training-plan/training-plan.component';
import { AddTrainingPlanComponent } from '../training-plan/add-training-plan/add-training-plan.component';
import { LearnerJobsModalComponent } from '../learner-jobs-modal/learner-jobs-modal.component';
import { LearnersListModalComponent } from '../learners-list-modal/learners-list-modal.component';
import { RapsComponent } from '../raps/raps.component';
import { LearnerListComponent } from '../learner-list/learner-list.component';



@NgModule({
  declarations: [
    MainLearnerComponent,
    LearnersComponent,
    SingleLearnerComponent,
    AddLearnerModalComponent,
    EditLearnerModalComponent,
    LearnerSubmissionComponent,
    LearnerAllotmentTileComponent,
    LearnerDashboardComponent,
    LearnerReadingMaterialComponent,
    ExamsResultsComponent,
    MatInputComponent,
    LearnerPortfolioComponent,
    PortfolioPolicyComponent,
    TrainingPlanComponent,
    AddTrainingPlanComponent,
    LearnerJobsModalComponent,
    LearnersListModalComponent,
    RapsComponent,
    LearnerListComponent
  ],
  imports: [
    CommonModule,
    MainLearnerRoutingModule,
    SharedModule,
    MaterialsModule,
    MainDocumentModule,
    MainMedicalModule,
    MainPortfolioModule,
    MainCourseModule
  ],
  entryComponents: [
    AddLearnerModalComponent,
    EditLearnerModalComponent,
    AddTrainingPlanComponent,
    LearnersListModalComponent
  ],
  exports: [
    LearnersComponent,
    ExamsResultsComponent,
    LearnerListComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainLearnerModule { }
